import arbitrum from '@/plugins/arbitrum'
import arbitrumNova from '@/plugins/arbitrumNova'
import avalanche from '@/plugins/avalanche'
import base from '@/plugins/base'
import bitcoin from '@/plugins/bitcoin'
import bitcoincash from '@/plugins/bitcoincash'
import bnbsmartchain from '@/plugins/bnbsmartchain'
import cosmos from '@/plugins/cosmos'
import dogecoin from '@/plugins/dogecoin'
import ethereum from '@/plugins/ethereum'
import gnosis from '@/plugins/gnosis'
import hyperevm from '@/plugins/hyperevm'
import litecoin from '@/plugins/litecoin'
import mayachain from '@/plugins/mayachain'
import mobile from '@/plugins/mobile'
import monad from '@/plugins/monad'
import near from '@/plugins/near'
import optimism from '@/plugins/optimism'
import plasma from '@/plugins/plasma'
import polygon from '@/plugins/polygon'
import solana from '@/plugins/solana'
import starknet from '@/plugins/starknet'
import sui from '@/plugins/sui'
import thorchain from '@/plugins/thorchain'
import tron from '@/plugins/tron'
import walletConnectToDapps from '@/plugins/walletConnectToDapps'
import zcash from '@/plugins/zcash'

export const activePlugins = [
  arbitrum,
  arbitrumNova,
  avalanche,
  base,
  bitcoin,
  bitcoincash,
  bnbsmartchain,
  cosmos,
  dogecoin,
  ethereum,
  gnosis,
  hyperevm,
  litecoin,
  mayachain,
  mobile,
  monad,
  near,
  optimism,
  plasma,
  polygon,
  solana,
  starknet,
  sui,
  thorchain,
  tron,
  walletConnectToDapps,
  zcash,
]
